import { ListBase, ResourceContextProvider } from "ra-core";
import { PaymentCalendar } from "../planning/PaymentCalendar";

/**
 * Forecast calendar: planned movements (income + expense) that are
 * still pending or overdue. Reuses the existing PaymentCalendar.
 */
export const PlanningCalendar = () => (
  <ResourceContextProvider value="payments">
    <ListBase
      perPage={500}
      sort={{ field: "planned_date", order: "ASC" }}
      filter={{ "status@in": "(pending,overdue)" }}
      disableSyncWithLocation
    >
      <PaymentCalendar />
    </ListBase>
  </ResourceContextProvider>
);
